import { render, staticRenderFns } from "./StateTranslationNeeded.vue?vue&type=template&id=752b40c4&scoped=true&"
import script from "./StateTranslationNeeded.vue?vue&type=script&lang=js&"
export * from "./StateTranslationNeeded.vue?vue&type=script&lang=js&"
import style0 from "./StateTranslationNeeded.vue?vue&type=style&index=0&id=752b40c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b40c4",
  null
  
)

component.options.__file = "StateTranslationNeeded.vue"
export default component.exports